
import MLBMediaItem from './mlb-media-item';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _find from 'lodash/find';

const selectedPredicate = (item) => item.selected;

/**
 *
 * @desc Playlist
 *
 */
class Playlist {

    constructor(items = [], currentClipId, topicId, mediaConfig, requestParams, CustomMetaDataLoader) {

        this.CustomMetaDataLoader = CustomMetaDataLoader;
        this.mediaConfig = mediaConfig;
        this._items = undefined;
        this.items = items;
        this.topicId = topicId;
        this.requestParams = requestParams;

        if(currentClipId) {

            this.setSelectedItem(currentClipId);

        }

    }

    set items(items) {

        this._items = items.map((item) => {

            if (this.CustomMetaDataLoader) {

                return new this.CustomMetaDataLoader(item, this.mediaConfig, this.requestParams);

            } else {

                return new MLBMediaItem(item, this.mediaConfig, this.requestParams);

            }


        });

    }

    get items() {

        return this._items;

    }

    get length() {

        return this._items.length;

    }

    /**
     *
     * @desc Sets selected to false on all list items
     *
     */
    unsetSelectedItem() {

        // Set all items to selected false
        this.items
            .forEach((item) => {

                _set(item, 'selected', false);

            });

    }

    /**
     *
     * @desc Sets the MediaItem with the specified contentId to "selected". If multiple
     * MediaItems exist in the playlist with the same contentId, the first one found
     * will be set to "selected"
     * @param {string} contentId The contentId of the MediaItem to be set as "selected"
     * @returns void
     *
     */
    setSelectedItem(contentId = '') {

        const clipInList = _find(this.items, { contentId });
        const currentClip = this.getSelectedItem();

        if(clipInList) {

            const clipMetaData = _get(clipInList, 'data');

            this.unsetSelectedItem();

            // Set the specified list item to selected
            _set(clipInList, 'selected', true);

            // Setting the metaDataJson will cache the metadata and not call getMetaData();
            if (clipMetaData) {

                _set(clipInList, 'metaDataJson', clipMetaData);

            }

            /** Stage the data for the next clip. No fetch call will be made if the
            metadata has already been cached */
            if (clipInList.prefetchNextItem) {

                const nextItem = this.items[this.getSelectedItemIndex() + 1] || this.items[0];
                !!nextItem ? nextItem.getMetaData() : null;

            }

        }

    }

    /**
     *
     * @desc set the selected item by index
     * @returns {AbstractMediaItem|undefined} If the selected item exists this will return the item
     * otherwise, `undefined` is returned.
     *
     */
    setSelectedItemByIndex(index) {

        const item = this.getItemByIndex(index);

        if(item) {

            this.setSelectedItem(item.contentId);

        }

        return item;

    }

    /**
     *
     * @desc Retrieve an item by index
     * @returns {AbstractMediaItem|undefined} If the selected item exists this will return the item
     *
     */
    getItemByIndex(index) {

        const item = this.items[index];

        return item;

    }

    /**
     *
     * @descReturns selected item. If there is no currently selected item
     * the first item in the list will be selected and returned.
     * @returns {AbstractMediaItem|undefined} If the selected item exists this will return the item
     *
     */
    getSelectedItem() {

        let selectedItem = this.items.find(selectedPredicate);

        return selectedItem;

    }

    /**
     *
     * Returns selected item
     * @returns {number}
     *
     */
    getSelectedItemIndex() {

        return this.items.findIndex(selectedPredicate);

    }

    /**
     *
     * Returns the next item to be played. If there is no selected item
     * select the first item
     * @returns {object}
     *
     */
    getNextItem() {

        return this.items[this.getSelectedItemIndex() + 1] || this.items[0];

    }

}

export default Playlist;
